module.exports = __webpack_public_path__ + "a162df7a8eb3fbb4dc84fb02efcc11f9.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/carousel/qello/6.png
// module id = 853
// module chunks = 0